import React from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';

const ConfirmDialog = ({ open, title, message, onConfirm, onCancel, isLoading = false }) => (
	<Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
		<DialogTitle>{title}</DialogTitle>
		<DialogContent>
			<DialogContentText>{message}</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={onCancel} disabled={isLoading}>
				Cancel
			</Button>
			<Button onClick={onConfirm} variant="contained" color="primary" disabled={isLoading}>
				{isLoading ? 'Processing...' : 'Confirm'}
			</Button>
		</DialogActions>
	</Dialog>
);

export default ConfirmDialog;
